/* Benji - Working Draft - custom interactions (drawer, contact popover, mobile call/text FAB) */
(function(){
  var body=document.body;

  /* ---- Mobile drawer ---- */
  var drawer=document.getElementById('mobileDrawer');
  var scrim=document.getElementById('drawerScrim');
  var openBtn=document.getElementById('navToggle');
  var closeBtn=document.getElementById('navClose');
  function openNav(){ if(!drawer) return;
    drawer.classList.add('open'); if(scrim) scrim.classList.add('show');
    drawer.setAttribute('aria-hidden','false'); if(openBtn) openBtn.setAttribute('aria-expanded','true');
    body.classList.add('nav-open'); }
  function closeNav(){ if(!drawer) return;
    drawer.classList.remove('open'); if(scrim) scrim.classList.remove('show');
    drawer.setAttribute('aria-hidden','true'); if(openBtn) openBtn.setAttribute('aria-expanded','false');
    body.classList.remove('nav-open'); }
  if(openBtn) openBtn.addEventListener('click',function(){ drawer.classList.contains('open')?closeNav():openNav(); });
  if(closeBtn) closeBtn.addEventListener('click',closeNav);
  if(scrim) scrim.addEventListener('click',closeNav);

  /* accordion groups inside drawer (single-open) */
  document.querySelectorAll('.dgroup .dtoggle').forEach(function(t){
    t.addEventListener('click',function(){
      var g=t.parentNode, isOpen=g.classList.contains('open');
      document.querySelectorAll('.dgroup.open').forEach(function(o){ if(o!==g){ o.classList.remove('open'); var b=o.querySelector('.dtoggle'); if(b) b.setAttribute('aria-expanded','false'); } });
      g.classList.toggle('open',!isOpen);
      t.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* ---- Contact popover (desktop header) ---- */
  var cToggle=document.getElementById('contactToggle');
  var cPop=document.getElementById('contactPop');
  function closePop(){ if(!cPop) return; cPop.classList.remove('open'); if(cToggle) cToggle.setAttribute('aria-expanded','false'); }
  if(cToggle&&cPop){
    cToggle.addEventListener('click',function(e){ e.stopPropagation();
      var isOpen=cPop.classList.toggle('open'); cToggle.setAttribute('aria-expanded',String(isOpen)); });
    document.addEventListener('click',function(e){
      if(cPop.classList.contains('open') && !cPop.contains(e.target) && e.target!==cToggle && !cToggle.contains(e.target)) closePop(); });
  }

  /* ---- Mobile call/text floating button ---- */
  var fab=document.getElementById('mfab');
  var fabBtn=document.getElementById('mfabBtn');
  function closeFab(){ if(!fab) return; fab.classList.remove('open'); if(fabBtn) fabBtn.setAttribute('aria-expanded','false'); }
  if(fab&&fabBtn){
    fabBtn.addEventListener('click',function(e){ e.stopPropagation();
      var isOpen=fab.classList.toggle('open'); fabBtn.setAttribute('aria-expanded',String(isOpen)); });
    document.addEventListener('click',function(e){ if(fab.classList.contains('open') && !fab.contains(e.target)) closeFab(); });
  }

  /* ---- Escape closes overlays ---- */
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeNav(); closePop(); closeFab(); } });
})();

/* ---- Spin: 360 video on product cards (30 Sep 2026) ----
   Cards with a GemLightbox video carry .pcard-has-vid and a muted <video>
   whose file sits in data-src. Nothing downloads until the first spin.
     desktop (real hover): spin on hover / keyboard focus, snap back on leave
     touch:               spin while the card is in the middle of the screen
   The photo only fades once the video fires 'playing' (.is-spinning), so a
   slow connection shows the photo, never a blank tile. Skipped entirely for
   prefers-reduced-motion, and on touch when the phone is in Save-Data mode.
   New cards (filters, load more) are picked up by the MutationObserver. */
(function(){
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  if(!canHover && saveData) return;

  function vidOf(card){ return card.querySelector('.pim-vid'); }

  function spin(card){
    var v = vidOf(card); if(!v) return;
    card._want = true;
    if(!v.getAttribute('src') && v.dataset.src){ v.src = v.dataset.src; }
    if(!v._wired){
      v._wired = true;
      v.addEventListener('playing', function(){ if(card._want) card.classList.add('is-spinning'); });
    }
    var pr = v.play(); if(pr && pr.catch) pr.catch(function(){});
  }

  function stop(card, rewind){
    var v = vidOf(card); if(!v) return;
    card._want = false;
    card.classList.remove('is-spinning');
    v.pause();
    if(rewind){ setTimeout(function(){ if(!card._want){ try{ v.currentTime = 0; }catch(e){} } }, 450); }
  }

  var io = null;
  if(!canHover && 'IntersectionObserver' in window){
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ en.isIntersecting ? spin(en.target) : stop(en.target, false); });
    }, { rootMargin: '-30% 0px -30% 0px', threshold: 0 });
  }

  function bind(card){
    if(card._spinBound) return; card._spinBound = true;
    if(canHover){
      card.addEventListener('mouseenter', function(){ spin(card); });
      card.addEventListener('mouseleave', function(){ stop(card, true); });
      card.addEventListener('focus', function(){ spin(card); });
      card.addEventListener('blur', function(){ stop(card, true); });
    } else if(io){
      io.observe(card);
    }
  }

  function scan(root){ (root || document).querySelectorAll('.pcard-has-vid').forEach(bind); }
  scan();

  if('MutationObserver' in window){
    new MutationObserver(function(muts){
      muts.forEach(function(m){ m.addedNodes.forEach(function(n){
        if(n.nodeType !== 1) return;
        if(n.classList && n.classList.contains('pcard-has-vid')) bind(n);
        if(n.querySelectorAll) scan(n);
      }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
